import { Mail, MessageCircle, Smartphone, X } from "lucide-react";
import { buildReminderLinks } from "../lib/reminderLinks";
import type { Appointment, Owner, Pet } from "../types";

interface ReminderSheetProps {
  open: boolean;
  appointment: Appointment | null;
  pet: Pet | null;
  owner: Owner | null;
  onClose(): void;
}

export function ReminderSheet({ open, appointment, pet, owner, onClose }: ReminderSheetProps) {
  if (!open || !appointment || !pet || !owner) return null;

  const links = buildReminderLinks(owner, pet, appointment);

  return (
    <div className="bottom-sheet-backdrop" role="presentation" onMouseDown={onClose}>
      <section className="bottom-sheet" role="dialog" aria-modal="true" aria-label="Wyślij przypomnienie" onMouseDown={(event) => event.stopPropagation()}>
        <div className="bottom-sheet__handle" />
        <div className="bottom-sheet__header">
          <div>
            <p className="eyebrow">Przypomnienie</p>
            <h2>{owner.fullName}</h2>
          </div>
          <button className="icon-button" type="button" aria-label="Zamknij" title="Zamknij" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <p className="bottom-sheet__copy">Wiadomość będzie już zawierać dane {pet.name} i termin wizyty.</p>
        <div className="reminder-options">
          <a href={links.sms} onClick={onClose} className="reminder-option">
            <span><Smartphone size={21} /></span> SMS
          </a>
          <a href={links.whatsapp} onClick={onClose} className="reminder-option" target="_blank" rel="noreferrer">
            <span><MessageCircle size={21} /></span> WhatsApp
          </a>
          {links.email ? (
            <a href={links.email} onClick={onClose} className="reminder-option">
              <span><Mail size={21} /></span> E-mail
            </a>
          ) : (
            <button type="button" className="reminder-option reminder-option--disabled" disabled title="Brak adresu e-mail">
              <span><Mail size={21} /></span> E-mail
            </button>
          )}
        </div>
      </section>
    </div>
  );
}
